<div>
  <!-- Filter Timesheet Form -->
  <h5>Filter User</h5>
  <form [formGroup]="filterForm" (ngSubmit)="onFilter()" style="display: flex;">
    <!-- User Selection -->
    <div class="field">
      <mat-form-field appearance="outline">
        <mat-label>User</mat-label>
        <mat-select formControlName="userIds" multiple>
          <mat-option>
              <ngx-mat-select-search
              [formControl]="userSearch.multiFilterCtrl"
              [placeholderLabel]="'Search User'"
              [noEntriesFoundLabel]="'No User Found'"
              [showToggleAllCheckbox]="true"
              [toggleAllCheckboxIndeterminate]="userSearch.isIndeterminate"
              [toggleAllCheckboxChecked]="userSearch.isChecked"
              (toggleAll)="userSearch.toggleSelectAll($event)"
              ></ngx-mat-select-search>
              </mat-option>
              @for (user of userSearch.filteredMulti | async; track user) {
                <mat-option [value]="user.id">{{user.name}}</mat-option>
              }
        </mat-select>
      </mat-form-field>
    </div> &nbsp;
    
    @if (isAdmin) {
      <!-- Department Selection -->
    <div class="field" *ngIf="!isTeamlead">
      <mat-form-field appearance="outline">
        <mat-label>Department</mat-label>
        <mat-select formControlName="departmentIds" multiple>
          <mat-option>
            <ngx-mat-select-search
            [formControl]="departmentSearch.multiFilterCtrl"
            [placeholderLabel]="'Search Department'"
            [noEntriesFoundLabel]="'No Department Found'"
            [showToggleAllCheckbox]="true"
            [toggleAllCheckboxIndeterminate]="departmentSearch.isIndeterminate"
            [toggleAllCheckboxChecked]="departmentSearch.isChecked"
            (toggleAll)="departmentSearch.toggleSelectAll($event)"
            ></ngx-mat-select-search>
            </mat-option>
            @for (department of departmentSearch.filteredMulti | async; track department) {
              <mat-option [value]="department.id">{{department.name}}</mat-option>
            }</mat-select>
      </mat-form-field>
    </div> &nbsp;
    }
    
    <!-- Role Selection -->
    <div class="field">
      <mat-form-field appearance="outline">
        <mat-label>Role</mat-label>
        <mat-select formControlName="roleIds" multiple>
          <mat-option>
            <ngx-mat-select-search
            [formControl]="roleSearch.multiFilterCtrl"
            [placeholderLabel]="'Search Role'"
            [noEntriesFoundLabel]="'No Role Found'"
            [showToggleAllCheckbox]="true"
            [toggleAllCheckboxIndeterminate]="roleSearch.isIndeterminate"
            [toggleAllCheckboxChecked]="roleSearch.isChecked"
            (toggleAll)="roleSearch.toggleSelectAll($event)"
            ></ngx-mat-select-search>
          </mat-option>
          @for (role of roleSearch.filteredMulti | async; track role) {
            <mat-option [value]="role.id">{{role.name}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div> &nbsp;
    
    <!-- Employee Type Selection -->
    <div class="field">
      <mat-form-field appearance="outline">
        <mat-label>Type</mat-label>
        <mat-select formControlName="employeeTypeIds" multiple>
          <mat-option>
            <ngx-mat-select-search
            [formControl]="employeeTypeSearch.multiFilterCtrl"
            [placeholderLabel]="'Search employeeType'"
            [noEntriesFoundLabel]="'No employeeType Found'"
            [showToggleAllCheckbox]="true"
            [toggleAllCheckboxIndeterminate]="employeeTypeSearch.isIndeterminate"
            [toggleAllCheckboxChecked]="employeeTypeSearch.isChecked"
            (toggleAll)="employeeTypeSearch.toggleSelectAll($event)"
            ></ngx-mat-select-search>
          </mat-option>
          @for (employeeType of employeeTypeSearch.filteredMulti | async; track employeeType) {
            <mat-option [value]="employeeType.id">{{employeeType.name}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div> &nbsp;
    
    <!-- Teamlead Filter -->
    <div class="field">
      <mat-form-field appearance="outline">
        <mat-label>Teamlead</mat-label>
        <mat-select formControlName="teamleadIds" multiple>
          <mat-option>
            <ngx-mat-select-search
              [formControl]="teamleadSearch.multiFilterCtrl"
              [placeholderLabel]="'Search Teamlead'"
              [noEntriesFoundLabel]="'No Teamlead Found'"
              [showToggleAllCheckbox]="true"
              [toggleAllCheckboxIndeterminate]="teamleadSearch.isIndeterminate"
              [toggleAllCheckboxChecked]="teamleadSearch.isChecked"
              (toggleAll)="teamleadSearch.toggleSelectAll($event)">
            </ngx-mat-select-search>
          </mat-option>
          @for (teamlead of teamleadSearch.filteredMulti | async; track teamlead) {
            <mat-option [value]="teamlead.id">{{ teamlead.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>&nbsp;&nbsp;

    <button mat-raised-button color="primary" type="submit">Filter</button> &nbsp;
    <button mat-raised-button color="primary" (click)="clearFilter()" type="button">Clear</button>
  </form>
  
  <button mat-raised-button color="accent" (click)="openBulkEditPopup()" style="margin-bottom: 15px;">
    Bulk Edit
  </button>

  <mat-paginator [length]="totalUsersCount"
    [pageSize]="pageSize"
    [pageSizeOptions]="[5, 10, 25, 100]"
    (page)="onPageChange($event)">
  </mat-paginator>

  <table mat-table [dataSource]="userData" class="demo-table">

    
<ng-container matColumnDef="select">
  <th mat-header-cell *matHeaderCellDef class="select-header-cell">
    <div class="select-all-wrapper">
      <mat-checkbox
        (change)="toggleSelectAll($event)"
        [checked]="isAllSelected()"
        [indeterminate]="isSomeSelected()">
      </mat-checkbox>
      <span class="select-all-label">Select All</span>
    </div>
  </th>
  <td mat-cell *matCellDef="let element" class="select-body-cell">
    <mat-checkbox
      (change)="toggleUserSelection(element.id, $event)"
      [checked]="isUserSelected(element.id)">
    </mat-checkbox>
  </td>
</ng-container>

    <!-- First Name Column -->
    <ng-container matColumnDef="firstName">
      <th mat-header-cell *matHeaderCellDef> First Name </th>
      <td mat-cell *matCellDef="let element">
        <span *ngIf="!element.editing">{{ element.firstName }}</span>
        <mat-form-field appearance="outline" *ngIf="element.editing">
          <input matInput [(ngModel)]="element.firstName">
        </mat-form-field>
      </td>
    </ng-container>
    
    <!-- Last Name Column -->
    <ng-container matColumnDef="lastName">
      <th mat-header-cell *matHeaderCellDef> Last Name </th>
      <td mat-cell *matCellDef="let element">
        <span *ngIf="!element.editing">{{ element.lastName }}</span>
        <mat-form-field appearance="outline" *ngIf="element.editing">
          <input matInput [(ngModel)]="element.lastName">
        </mat-form-field>
      </td>
    </ng-container>
    
    <!-- User Name Column -->
    <ng-container matColumnDef="userName">
      <th mat-header-cell *matHeaderCellDef> User Name </th>
      <td mat-cell *matCellDef="let element">
        <span *ngIf="!element.editing">{{ element.userName }}</span>
        <mat-form-field appearance="outline" *ngIf="element.editing">
          <input matInput [(ngModel)]="element.userName">
        </mat-form-field>
      </td>
    </ng-container>
    
    <!-- Contact Column -->
    <ng-container matColumnDef="contact">
      <th mat-header-cell *matHeaderCellDef> Contact </th>
      <td mat-cell *matCellDef="let element">
        <span *ngIf="!element.editing">{{ element.contact }}</span>
        <mat-form-field appearance="outline" *ngIf="element.editing">
          <input matInput [(ngModel)]="element.contact">
        </mat-form-field>
      </td>
    </ng-container>
    
    <!-- Email Column -->
    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef> Email </th>
      <td mat-cell *matCellDef="let element">
        <span *ngIf="!element.editing">{{ element.email }}</span>
        <mat-form-field appearance="outline" *ngIf="element.editing">
          <input matInput [(ngModel)]="element.email">
        </mat-form-field>
      </td>
    </ng-container>
    
    <!-- Department Column -->
    <ng-container matColumnDef="department">
      <th mat-header-cell *matHeaderCellDef> Department </th>
      <td mat-cell *matCellDef="let element">
        <span *ngIf="!element.editing">{{ getDepartmentName(element.departmentId) }}</span>
        <mat-form-field appearance="outline" *ngIf="element.editing">
          <mat-select [(ngModel)]="element.departmentId" (selectionChange)="onDepartmentChange($event.value, element)" [disabled]="getRoleName(element.roleId) == roleNameEnum.ADMIN">
            <mat-option *ngFor="let department of departments" [value]="department.id">{{ department.departmentName }}</mat-option>
          </mat-select>
        </mat-form-field>
      </td>
    </ng-container>
    
    <!-- Employee Code Column -->
    <ng-container matColumnDef="employeeCode">
      <th mat-header-cell *matHeaderCellDef> Employee Code </th>
      <td mat-cell *matCellDef="let element">
        <span *ngIf="!element.editing">{{ element.employeeCode }}</span>
        <mat-form-field appearance="outline" *ngIf="element.editing">
          <input matInput [(ngModel)]="element.employeeCode">
        </mat-form-field>
      </td>
    </ng-container>
    
    <!-- Joining Date Column -->
    <ng-container matColumnDef="joiningDate">
      <th mat-header-cell *matHeaderCellDef> Joining Date </th>
      <td mat-cell *matCellDef="let element">
        <span *ngIf="!element.editing">{{ element.joiningDate | date: 'dd-MM-yyyy' }}</span>
        <mat-form-field appearance="outline" *ngIf="element.editing">
          <input matInput [matDatepicker]="joiningDatePicker" [(ngModel)]="element.joiningDate">
          <mat-datepicker-toggle matSuffix [for]="joiningDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #joiningDatePicker></mat-datepicker>
        </mat-form-field>
      </td>
    </ng-container>
    
    <!-- Birth Date Column -->
    <ng-container matColumnDef="birthDate">
      <th mat-header-cell *matHeaderCellDef> Birth Date </th>
      <td mat-cell *matCellDef="let element">
        <span *ngIf="!element.editing">{{ element.birthDate | date: 'dd-MM-yyyy' }}</span>
        <mat-form-field appearance="outline" *ngIf="element.editing">
          <input matInput [matDatepicker]="birthDatePicker" [(ngModel)]="element.birthDate">
          <mat-datepicker-toggle matSuffix [for]="birthDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #birthDatePicker></mat-datepicker>
        </mat-form-field>
      </td>
    </ng-container>
    
    <!-- Role Column -->
    <ng-container matColumnDef="role">
      <th mat-header-cell *matHeaderCellDef> Role </th>
      <td mat-cell *matCellDef="let element">
        <span *ngIf="!element.editing">{{ getRoleName(element.roleId) }}</span>
        <mat-form-field appearance="outline" *ngIf="element.editing" required="true">
          <mat-select [(ngModel)]="element.roleId">
            <mat-option *ngFor="let role of roles" [value]="role.id">{{ role.role }}</mat-option>
          </mat-select>
        </mat-form-field>
      </td>
    </ng-container>
    
    <!-- Employee Type Column -->
    <ng-container matColumnDef="employeeType">
      <th mat-header-cell *matHeaderCellDef> Employee Type </th>
      <td mat-cell *matCellDef="let element">
        <span *ngIf="!element.editing">{{ getEmployeeTypeName(element.employeeTypeId) }}</span>
        <mat-form-field appearance="outline" *ngIf="element.editing">
          <mat-select [(ngModel)]="element.employeeTypeId">
            <mat-option *ngFor="let employeeType of employeeTypes" [value]="employeeType.id">{{ employeeType.type }}</mat-option>
          </mat-select>
        </mat-form-field>
      </td>
    </ng-container>

    <!-- Teamlead Column -->
    <ng-container matColumnDef="teamleads">
      <th mat-header-cell *matHeaderCellDef> Teamleads </th>
      <td mat-cell *matCellDef="let element">
        <span *ngIf="!element.editing">{{getTeamleadNames(element.teamleads) }}</span>
        <mat-form-field appearance="outline" *ngIf="element.editing">
          <mat-select [(ngModel)]="element.teamleads" multiple [compareWith]="compareTeamlead">
            <mat-option *ngFor="let tl of filteredTeamleads" [value]="tl">{{ tl.name }}</mat-option>
          </mat-select>
        </mat-form-field>
      </td>
    </ng-container>
    
    <!-- Actions Column -->
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef> Actions </th>
      <td mat-cell *matCellDef="let element">
        <button mat-raised-button color="primary" *ngIf="!element.editing" (click)="editUser(element)">Edit</button> &nbsp;
        <button mat-raised-button color="warn" *ngIf="!element.editing" (click)="deleteUser(element)">Delete</button> &nbsp;
        <button mat-stroked-button color="warn" *ngIf="!element.editing" (click)="toggleUserStatus(element)">{{ element.isDisabled ? 'Enable' : 'Disable' }}</button> &nbsp;
        <button mat-raised-button color="secondary" *ngIf="!element.editing" (click)="softDeleteUser(element)">{{element.isDeleted ? 'Undo Delete': "Soft Delete"}}</button> &nbsp;
        <button mat-raised-button color="secondary" *ngIf="!element.editing" (click)="resetUser(element)">Reset</button> &nbsp;
        <button mat-raised-button color="primary" *ngIf="element.editing" (click)="saveUser(element)">Save</button> &nbsp;
        <button mat-raised-button *ngIf="element.editing" (click)="cancelEdit(element)">Cancel</button>
      </td>
    </ng-container>
    
    <tr mat-header-row *matHeaderRowDef="isAdmin || isDepartmentAdmin? displayedColumns : teamleadDisplayedColumns"></tr>
    <tr
      mat-row
      *matRowDef="let user; columns: isAdmin || isDepartmentAdmin? displayedColumns : teamleadDisplayedColumns;"
      [class.disabled-user-row]="user.isDisabled">
    </tr>
  </table>
</div>

<!-- Bulk Edit Popup -->
<div class="bulk-popup" *ngIf="bulkEditPopupOpen">
  <div class="popup-content">

    <h3>Bulk Edit Users</h3>

    <form [formGroup]="bulkEditForm">

      <!-- Role -->
      <mat-form-field appearance="outline" style="width:100%;">
        <mat-label>Role</mat-label>
        <mat-select formControlName="roleId">
          <mat-option *ngFor="let role of roles" [value]="role.id">
            {{ role.role }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Employee Type -->
      <mat-form-field appearance="outline" style="width:100%;">
        <mat-label>Employee Type</mat-label>
        <mat-select formControlName="employeeTypeId">
          <mat-option *ngFor="let type of employeeTypes" [value]="type.id">
            {{ type.type }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Teamlead -->
      <mat-form-field appearance="outline" style="width:100%;">
        <mat-label>Teamlead</mat-label>
        <mat-select formControlName="teamleads" multiple>
          <mat-option *ngFor="let tl of filteredTeamleads" [value]="tl">
            {{ tl.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>

    </form>

    <div style="display:flex; gap:10px; justify-content:end;">
    <button mat-raised-button color="primary" (click)="saveBulkEdit()">
  Save
</button>
      <button mat-raised-button (click)="closeBulkEditPopup()">
        Cancel
      </button>
    </div>

  </div>
</div>
